import React, { useState } from 'react';
import {
    Box,
    Container,
    createStyles,
    Dialog,
    Grid,
    IconButton,
    makeStyles,
    Radio,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Theme
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { Search } from '@material-ui/icons';
import useCommonApi from '../../api/useCommonApi';
import ReactLoading from 'react-loading';
import CloseIcon from '@material-ui/icons/Close';
import Help, { IHelp } from '../help/Help';
import { getDireccionDistribuidor } from "../../blocks/utility";
import DatosComplementarios from "./DatosComplementarios";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



interface Props {
    abierto: boolean
    confirmar: () => void
    cerrar: () => void
    maxWidth?: 'lg' | 'md' | 'sm' | 'xl'
    setDistribuidor: (direccion: any) => void
    cliente: any
    esOrigen: boolean
    ayuda?: IHelp
    usuario: any
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            backgroundColor: "#fff",
            margin: "0px",
            padding: "10px",
        },
        container: {
            backgroundColor: "#e5e5e5",
        },
        text: {
            backgroundColor: "#fff",
            textTransform: "uppercase"
        },
        div_rfc: {
            width: '100%',
        },
        label: {
            fontSize: '15px',
            width: "200px",
            paddingTop: "20px"
        },
        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        iconSm: {
            width: "20px",
            height: "30px",
            minWidth: "20px",
            borderRadius: "15px",
            color: "#fff",
            textAlign: "center",
        },
        actions: {
            textAlign: "center",
            width: "100%",
            display: "block",
            padding: "30px 0px"
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            minWidth: 650,

        },
        loading: {
            height: "300px",
            width: "100%",
            textAlign: "center"
        },
        padding: {
            padding: "10px 0px"
        },
        tableWrapper: {
            overflowX: 'auto',
            overflowY: 'auto',
            height: '300px',
            width: "100%",
        },
        noOverflow: {
            overflow: 'hidden'
        }
    }),
);

const RecoleccionDireccion = ({ abierto, cerrar, confirmar, maxWidth, setDistribuidor, cliente, esOrigen,
    ayuda, usuario }: Props) => {
    const classes = useStyles();
    const apiSource = useCommonApi();

    const [showLoading, setLoading] = useState(false);
    const [clienteId, setClienteId] = useState('');
    const [clienteNombre, setClienteNombre] = useState('');
    const [distribuidorSeleccionado, setDistribuidorSeleccionado] = useState({ clienteDistribuidorComplementos: false });
    const [direcciones, setDirecciones] = useState<any[]>([]);
    const [selectedValue, setSelectedValue] = useState('0');
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [direccion, setDireccion] = useState('');
    const [habilitarContinuar, setHabilitarContinuar] = useState(false);
    const [showModalDatosComplementarios, setShowModalDatosComplementarios] = useState(false);

    const handleChange = (distribuidor) => {
        setHabilitarContinuar(false);
        setSelectedValue(distribuidor.id);
        setDistribuidorSeleccionado(distribuidor);

        setHabilitarContinuar(true);
    };

    React.useEffect(() => {
        buscarCliente();
    }, []);

    const getDireccion = async () => {
        return await apiSource.obtenerAsync<any>("cliente-distribuidor/by-filtro/" + cliente.id, {
            nombre: clienteNombre !== '' ? clienteNombre : null,
            distribuidor: clienteId !== '' ? clienteId : null,
            direccion: direccion !== '' ? direccion : null,
            esOrigen: esOrigen,
            filtrar: 1
        });
    };

    const selectDistribuidor = () => {
        if (!distribuidorSeleccionado?.clienteDistribuidorComplementos && cliente.habilitarDatosComplementarios) {
            setShowModalDatosComplementarios(true);
            return;
        }

        setDistribuidor(distribuidorSeleccionado);
        confirmar();
    };

    const buscarCliente = () => {
        setLoading(true);

        getDireccion().then(data => {
            let direccionesDistribuidor: any[] = [];

            if (data !== null && data.length) {
                data.forEach(s => {
                    let distribuidor = {
                        ...s,
                        id: s.clienteDistribuidorID,
                        nombre: s.nombreClienteDistribuidor,
                        direccion: getDireccionDistribuidor(s),
                        clienteDistribuidorId: s.clienteDistribuidorID,

                    };
                    direccionesDistribuidor.push(distribuidor);
                });
            }

            setDirecciones(direccionesDistribuidor);
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const cerrarDatosComplementarios = () => {
        setShowModalDatosComplementarios(false);
    };

    const confirmarDatosComplementarios = () => {
        setShowModalDatosComplementarios(false);
        confirmar();
    };

    return (<>
        <Dialog open={abierto} maxWidth={maxWidth ? maxWidth : "xl"} fullWidth={true} onClose={cerrar} style={{ zIndex: 1000 }}>
            <DialogTitle id="simple-dialog-title" >
                <Box display="flex" alignItems="center">
                    <Box>
                        <Help comments={traducirMessage(2)} customStyle={{ top: "-40px", right: "-25px" }} />
                    </Box>
                    <Box flexGrow={1} textAlign="center">{esOrigen ? traducirLabel(336) : traducirLabel(337)}</Box>
                    <Box>
                        <IconButton onClick={cerrar}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>



            </DialogTitle>
            <DialogContent className={classes.noOverflow} dividers>
                <DialogContentText>
                    <Container maxWidth="xl" className={classes.principal} >

                        <Grid container spacing={3} className={classes.container}>
                            <Grid item xs={1}>
                                <div className={classes.label}>
                                    {/* Id Distribuidor */
                                        traducirLabel(159)}
                                </div>
                            </Grid>
                            <Grid item xs={2}>
                                <div className={classes.div_rfc}>
                                    <form className={classes.root} noValidate autoComplete="off">
                                        <TextField id="outlined-basic" className={classes.text}
                                            value={clienteId}
                                            onChange={e => setClienteId(e.target.value as string)}
                                            variant="outlined" fullWidth
                                        />
                                    </form>

                                </div>
                            </Grid>
                            <Grid item xs={1}>
                                <div className={classes.label}>
                                    {/* Nombre */
                                        traducirLabel(201)}
                                </div>
                            </Grid>
                            <Grid item xs={3}>
                                <div className={classes.div_rfc}>
                                    <form className={classes.root} noValidate autoComplete="off">
                                        <TextField id="outlined-basic" className={classes.text}
                                            value={clienteNombre}
                                            onChange={e => setClienteNombre(e.target.value)}
                                            variant="outlined" fullWidth />
                                    </form>

                                </div>
                            </Grid>
                            <Grid item xs={1}>
                                <div className={classes.label}>
                                    {/* Dirección */
                                        traducirLabel(95)}
                                </div>
                            </Grid>
                            <Grid item xs={3}>
                                <div className={classes.div_rfc}>
                                    <form className={classes.root} noValidate autoComplete="off">
                                        <TextField id="outlined-basic" className={classes.text}
                                            value={direccion}
                                            onChange={e => setDireccion(e.target.value)}
                                            variant="outlined" fullWidth />
                                    </form>

                                </div>
                            </Grid>
                            <Grid item xs={1}>
                                <Button className={classes.icon} color="primary" variant="outlined" onClick={() => buscarCliente()} disabled={showLoading}>
                                    <Search />
                                </Button>
                            </Grid>


                        </Grid>
                    </Container>


                    <div className={classes.tableWrapper}>
                        <TableContainer >
                            <Table className={classes.table} aria-label="simple table"  >
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell>
                                            {/* ID DISTRIBUIDOR */
                                                traducirLabel(159)}
                                        </TableCell>
                                        <TableCell>
                                            {/* NOMBRE */
                                                traducirLabel(201)}
                                        </TableCell>
                                        <TableCell>
                                            {/* DIRECCIÓN */
                                                traducirLabel(95)}
                                        </TableCell>
                                        <TableCell>
                                            {/* TIPO PERSONA */
                                                traducirLabel(304)}
                                        </TableCell>
                                        <TableCell>
                                            {/* RFC */
                                                traducirLabel(268)}
                                        </TableCell>
                                        <TableCell>
                                            {/* NO. IDENTIFICACIÓN FISCAL */
                                                traducirLabel(197)}
                                        </TableCell>
                                        <TableCell>
                                            {/* RESIDENCIA FISCAL */
                                                traducirLabel(263)}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {(showLoading) &&
                                        <TableRow key={0}>
                                            <TableCell colSpan={7} component="th" scope="row" style={{ paddingLeft: "50%" }}>
                                                <ReactLoading type="spin" color="#19754e" height={40} width={40} />
                                            </TableCell>
                                        </TableRow>
                                    }
                                    {(rowsPerPage > 0
                                        ? direcciones.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        : direcciones
                                    ).map((row, i) => (
                                        <TableRow key={i}>
                                            <TableCell component="th" scope="row">
                                                <Radio checked={Number(selectedValue) === row.id}
                                                    value={row.id}
                                                    onChange={() => handleChange(row)}
                                                    name="radio-button-demo"
                                                    inputProps={{ 'aria-label': 'A' }}
                                                />
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.id}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.nombre}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.direccion}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                { localStorage.getItem("idioma")==="en-US" ? row.clienteDistribuidorComplementos?.tipoPersona?.etiquetaTipoPersona?.nombre : row.clienteDistribuidorComplementos?.tipoPersona?.nombre }
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.clienteDistribuidorComplementos?.rfc}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.clienteDistribuidorComplementos?.numeroIdentificaciónFiscal}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {row.clienteDistribuidorComplementos?.residenciaFiscal}
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={direcciones.length}
                                rowsPerPage={rowsPerPage}
                                labelRowsPerPage=''
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </TableContainer>
                    </div>


                </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button variant="contained" autoFocus onClick={selectDistribuidor} color="primary"
                    disabled={selectedValue === '0' || !habilitarContinuar}>
                    {/* Continuar */
                        traducirButton(7)}
                </Button>
            </DialogActions>
        </Dialog>

        {showModalDatosComplementarios &&
            <DatosComplementarios abierto={showModalDatosComplementarios} cerrar={cerrarDatosComplementarios}
                setDatos={setDistribuidor} confirmar={confirmarDatosComplementarios} cliente={cliente}
                usuario={usuario} clienteDistribuidor={distribuidorSeleccionado} />
        }

    </>)
};

export default RecoleccionDireccion;
